import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

function PolicyEditor({ value = '', onChange }) {
  return (
    <div className="ck-wrapper" style={{ minHeight: '400px' }}>
      <CKEditor
        editor={ClassicEditor}
        data={value}
        config={{
          placeholder: 'Escreva sua política aqui...',
          toolbar: {
            items: [
              'heading', '|',
              'fontSize', 'fontFamily', '|',
              'bold', 'italic', 'underline', 'strikethrough', '|',
              'fontColor', 'fontBackgroundColor', '|',
              'alignment', '|',
              'bulletedList', 'numberedList', '|',
              'outdent', 'indent', '|',
              'link', 'insertTable', 'imageUpload', 'mediaEmbed', '|',
              'blockQuote', 'horizontalLine', '|',
              'undo', 'redo', '|',
              'findAndReplace', 'removeFormat'
            ],
            shouldNotGroupWhenFull: true
          },
          heading: {
            options: [
              { model: 'paragraph', title: 'Parágrafo', class: 'ck-heading_paragraph' },
              { model: 'heading1', view: 'h1', title: 'Título 1', class: 'ck-heading_heading1' },
              { model: 'heading2', view: 'h2', title: 'Título 2', class: 'ck-heading_heading2' },
              { model: 'heading3', view: 'h3', title: 'Título 3', class: 'ck-heading_heading3' },
              { model: 'heading4', view: 'h4', title: 'Título 4', class: 'ck-heading_heading4' }
            ]
          },
          fontSize: {
            options: [
              9, 10, 11, 12, 13, 14, 15, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36
            ]
          },
          fontFamily: {
            options: [
              'default',
              'Arial, Helvetica, sans-serif',
              'Courier New, Courier, monospace',
              'Georgia, serif',
              'Lucida Sans Unicode, Lucida Grande, sans-serif',
              'Tahoma, Geneva, sans-serif',
              'Times New Roman, Times, serif',
              'Trebuchet MS, Helvetica, sans-serif',
              'Verdana, Geneva, sans-serif'
            ]
          },
          table: {
            contentToolbar: [
              'tableColumn', 'tableRow', 'mergeTableCells',
              'tableProperties', 'tableCellProperties'
            ]
          },
          image: {
            toolbar: [
              'imageTextAlternative',
              'toggleImageCaption',
              'imageStyle:inline',
              'imageStyle:block',
              'imageStyle:side',
              'linkImage'
            ]
          },
          link: {
            decorators: {
              addTargetToExternalLinks: true,
              defaultProtocol: 'https://'
            }
          },
          alignment: {
            options: ['left', 'center', 'right', 'justify']
          },
          // Configurações para melhor experiência similar ao Word
          typing: {
            transformations: {
              extra: [
                { from: /\(c\)/gi, to: '©' },
                { from: /\(r\)/gi, to: '®' },
                { from: /\(tm\)/gi, to: '™' },
                { from: /1\/2/g, to: '½' },
                { from: /1\/4/g, to: '¼' },
                { from: /3\/4/g, to: '¾' }
              ]
            }
          },
          // Paste-from-Office já incluso no build clássico
          htmlSupport: {
            allow: [
              {
                name: /.*/,
                attributes: true,
                classes: true,
                styles: true
              }
            ]
          }
        }}
        onChange={(_, editor) => {
          onChange(editor.getData());
        }}
        onReady={(editor) => {
          // Configurar altura mínima do editor
          const editable = editor.ui.getEditableElement();
          if (editable) {
            editable.style.minHeight = '300px';
            editable.style.padding = '20px';
            editable.style.lineHeight = '1.6';
            editable.style.fontSize = '14px';
          }
        }}
      />
      <style>{`
        .ck-wrapper .ck-editor__editable {
          min-height: 300px !important;
          padding: 20px !important;
          line-height: 1.6 !important;
          font-size: 14px !important;
          font-family: 'Times New Roman', Times, serif !important;
        }
        .ck-wrapper .ck-toolbar {
          border-radius: 4px 4px 0 0 !important;
        }
        .ck-wrapper .ck-editor__main {
          border-radius: 0 0 4px 4px !important;
        }
      `}</style>
    </div>
  );
}

export default PolicyEditor;
